import React, { useState, useEffect } from "react";
import { Tab, Nav, Container, Row, Col, Button, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import { v4 as uuidv4 } from "uuid";
import ScriptBoxes from "components/client_config/ppc_config/ScriptBoxes";

export default function Scripts(props) {
	let exclaimTriangle = require("images/icons/exclaim-triangle.png");
	exclaimTriangle = <img className="mr-md-3 mr-0" width="25" height="23" src={`/datapulse${exclaimTriangle}`} />;

  const scripts = [
    {
      name: "text_converting_query_mining_script",
      title: "Text converting query mining script",
      desc: "Monthly iterates through all text campaign converted queries on an account for the previous two months and creates ad groups based on the converted query text.",
    },
    {
      name: "em_bm_negative_overlap_script",
      title: "EM/BM negative overlap script",
      desc: "Syncs negative keyword lists throughout the account to prevent overlap.",
    },
    {
      name: "negative_dsa_sync_script",
      title: "Negative DSA sync script",
      desc: "Syncs enabled account keywords as negatives in the '[DSA]' ad group to prevent bidding on pre_targeted queries.",
    },
    {
      name: "exclude_nb_in_shopping",
      title: "Exclude Non-Brand in Shopping",
      desc: "When you split Shopping campaigns on branded and non-branded search terms, you often still get non-branded search terms in your branded Shopping campaign(s). This script automatically excludes these terms.",
    },
    {
      name: "keyword_cannibalization_script",
      title: "Keyword Cannibalization Script",
      desc: "For every ad group in the entire account, adds all keywords NOT in that ad group to be an exact match negative version to that ad group.",
    },
    {
      name: "youtube_channel_excluder",
      title: "Exclude Foreign Language YouTube Channels",
      desc: "For display and video campaigns, Google is not quite so particular about targeting individual languages and video ads are often played in foreign language channels. This script identifies YouTube channels in undesired countries on which the video campaign(s) was/are played and automatically excludes them from the respective campaign.",
    },
  ];

	return (
		<>
      <Container className="pb-5 pl-md-4 pr-md-5 p-3" fluid>
        <Row>
          <Col>
            <div className="py-4 px-3">
              <p className="text-info text-center text-md-left f18 visby-bold pb-4">Scripts:</p>
              <div className="exclaim-triangle">{exclaimTriangle}</div>
              <p className="d-inline-block f14 nunito-regular primary mb-0" style={{ maxWidth: "600px", verticalAlign: "middle" }}>
                Enabling/disabling these scripts without a thorough understanding of the function may have unintended consequences. Please proceed with caution.
              </p>
            </div>
          </Col>
        </Row>
        <Row className="script-row px-3">
          <ScriptBoxes scripts={scripts} client_account={props.client_account} />
        </Row>
      </Container>
		</>
	);
}
